import styled, { keyframes } from 'styled-components';
import { hideVisually } from 'polished';
var AnimationSpin = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
export var StyledSpinner = styled.div.withConfig({
  displayName: "Spinnerstyles__StyledSpinner",
  componentId: "sc-1p6p0qg-0"
})(["width:", ";height:", ";border-radius:100px;display:inline-block;border-style:solid;border-color:inherit;border-bottom-color:transparent;border-left-color:transparent;border-width:", ";animation:", " ", " linear infinite;"], function (props) {
  return props.spinnerSize;
}, function (props) {
  return props.spinnerSize;
}, function (props) {
  return props.spinnerThickness;
}, AnimationSpin, function (props) {
  return props.spinnerSpeed;
});
export var StyledSpinnerLabel = styled.span.withConfig({
  displayName: "Spinnerstyles__StyledSpinnerLabel",
  componentId: "sc-1p6p0qg-1"
})(["", ""], hideVisually);